import QuantityProduct from './QuantityProduct'

class DronePhotoProduct extends QuantityProduct {
  static MINIMUM_QUANTITY = 5
}

export default DronePhotoProduct
